<mat-drawer-container class="flex-fill"
                      autosize="true">
  <mat-drawer #drawer mode="side">
    <app-navigation [menu]="menu"></app-navigation>
  </mat-drawer>

  <mat-drawer-content class="d-flex flex-column flex-nowrap position-relative">
    <app-navbar></app-navbar>
    <div [style.transform]="drawer.opened ? 'translate(-52px, 0)' : 'translate(0, 0)'"
         class="position-absolute start-0 bg-white narrow-navigation"
         [class.mat-drawer-side]="!drawer.opened">
      <app-narrow-navigation [menu]="menu"></app-narrow-navigation>
    </div>
    <div style="transition: padding-left .2s ease-in-out;"
         [style.padding-left]="drawer.opened ? null : '68px !important'"
         class="d-flex flex-row flex-nowrap align-items-start justify-content-start p-3 container-page">
      <router-outlet class="d-none"></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>